<div class="td-cnt-ext-extra-cost">
    <div class="td-cnt-extra-cost">
        <div class="td-cnt-title">
            <span class="te-title">{{'enquiryBook.extraCosts' | translate}}</span>
        </div>
        <div class="td-cnt-body-dto" *ngIf="!isLoading">
            <div *ngFor="let cost of itemExtraCosts?.itemExtraCosts; let i = index" class="extra-cost-item">

                <!-- Extra Cost Select Dropdown -->
                <div style="min-width: 20vw;">
                    <teiasoft-select [labelText]="'grid.extraCost' | translate" [isMobile]="isMobile"
                        [disabled]="isOrderExtraCost(cost)" [optionsList]="extraCostOptionsByRow[i] || []"
                        [spaceLabel]="true" [noMinWidth]="true" [isValid]="true" 
                        (onSelected)="onExtraCostChange($event.value, i)"
                        [defaultValue]="cost.extraCostId" [readOnly]="readOnly" [isRequired]="true"></teiasoft-select>
                </div>

                <!-- Amount Input -->
                <div>
                    <teiasoft-input [type]="'number'" [labelText]="'grid.extraCostAmount' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="isOrderExtraCost(cost)"
                        [value]="cost.extraCostAmount" (onInput)="onInputAmount($event,i)" [isValid]="true"
                        [readOnly]="readOnly" [allowNegative]="true"></teiasoft-input>
                </div>

                <!-- UOM Select Dropdown -->
                <div>
                    <teiasoft-select [labelText]="'grid.extraCostUom' | translate" [isMobile]="isMobile"
                        [disabled]="isOrderExtraCost(cost)" [optionsList]="uomOptionsList[cost.extraCostId!] || []"
                        [spaceLabel]="true" [noMinWidth]="true" [isValid]="true"
                        (onSelected)="onExtraCostUomChange($event.value, i)" [defaultValue]="cost.extraCostUom"
                        [readOnly]="readOnly" [isRequired]="true" [disableOptionSort]="true"></teiasoft-select>
                </div>

                <!-- Test Amount Input -->
                <div *ngIf="isPerTestUom(cost.extraCostUom)">
                    <teiasoft-input [type]="'number'" [labelText]="'grid.extraCostTestAmount' | translate"
                        [isMobile]="isMobile" [isRequired]="true" [disabled]="false" [value]="cost.numberOfTests"
                        (onInput)="onInputTestAmount($event,i)" [isValid]="true" [readOnly]="readOnly"
                        [allowNegative]="false"></teiasoft-input>
                </div>

                <!-- Remove Button -->
                <div *ngIf="!readOnly && !isOrderExtraCost(cost)" class="row-actions">
                    <button class="teia-tt-button tb-primary" (click)="removeExtraCost(i)"><i
                            class="fal fa-trash"></i></button>
                </div>
            </div>
        </div>

        <!-- Add Extra Cost Button -->
        <button *ngIf="!readOnly" class="teia-tt-button tb-primary" (click)="addExtraCost()"><i
                class="fal fa-plus"></i></button>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (click)="onCancelClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [isMobile]="isMobile" class="mr-5"></teiasoft-button>
            <teiasoft-button *ngIf="!readOnly" (click)="onSaveClick()" [type]="'tb-primary'"
                [text]="'commons.save' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
